import styled from "styled-components";
import nbLogo from "./NbLogo.png"

const Logo = styled.img`
   display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    height: 30px;
`

export default () => (
    <Logo src={"/logo-고용노동부.png"} alt={"스파르타 국비지원"}/>
)
